import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ActivityDataService {
    private reloadActivityData = new Subject<any>();

    constructor() { }

    sendData(message: {reload: boolean}) {
        this.reloadActivityData.next(message);
    }

    clearData() {
        this.reloadActivityData.next(null);
    }

    reloadActivity(){
        this.sendData({ reload: true });

        setTimeout(()=>{
            this.sendData(null);
        },100)
    }

    getData(): Observable<{reload: boolean}> {
        return this.reloadActivityData.asObservable();
    }
}
